import React from 'react';
import { Placeholder } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';

interface IDiscoveryFavoritesRowSkeletonProps {
    isClient?: boolean;
    isGlobal?: boolean;
    isBundle?: boolean;
}

const Cell = ({ shape = 'skeleton-table-cell' }: { shape?: string }) => (
    <td className="text-center align-middle">
        <Placeholder className={`skeleton ${shape}`} />
    </td>
);

export function DiscoveryFavoritesRowSkeleton({
    isClient = false,
    isGlobal = false,
    isBundle = false,
}: IDiscoveryFavoritesRowSkeletonProps) {
    const canViewPurchaseOrder = useSelector((state: IAllStates) => state.auth.user.company?.canViewPurchaseOrder);
    const showActions = isBundle ? !isClient : true;

    return (
        <tr className="bg-white shadow-sm default-radius p-3 placeholder-glow" aria-hidden="true">
            <td className="mx-2 position-sticky bg-white left-0 pr-0 z-index-2" style={{ zIndex: 1 }}>
                <div className="d-flex align-items-center border-right">
                    <Placeholder className="skeleton skeleton-favorite-avatar me-3" />
                    <div className="mx-2">
                        <Placeholder className="skeleton skeleton-table-name d-block" />
                        <Placeholder className="skeleton skeleton-table-cell d-block mt-2" />
                    </div>
                </div>
            </td>
            <Cell shape="skeleton-platform-icon" />
            <Cell shape="skeleton-table-cell-wide" />
            <Cell shape="skeleton-badge" />
            <Cell />
            <Cell />
            <Cell />
            <Cell />
            {Array.from({ length: 3 }).map((_, i) => (
                <td key={i} className="text-center align-middle">
                    <div className="d-flex justify-content-center align-items-center" style={{ gap: 4 }}>
                        <Placeholder className="skeleton skeleton-flag" />
                        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm" />
                    </div>
                </td>
            ))}

            <td className="align-middle">
                <div className="d-flex align-items-center">
                    {Array.from({ length: 3 }).map((_, i) => (
                        <Placeholder key={i} className="skeleton skeleton-flag" style={{ marginLeft: i ? -8 : 0 }} />
                    ))}
                </div>
            </td>
            <Cell />
            {canViewPurchaseOrder && <Cell />}
            {!isGlobal && <Cell shape="skeleton-header-icon" />}
            <Cell shape="skeleton-header-icon" />
            {!isGlobal && <Cell shape="skeleton-header-icon" />}
            {showActions && <Cell shape="skeleton-icon" />}
            <td className="text-end align-middle pr-2">
                <Placeholder className="skeleton skeleton-outline-btn skeleton-btn-sm" />
            </td>
        </tr>
    );
}
